<template>
  <div class="container products-center-list">
    <div class="main-banner">
      <img src="@/assets/img/products-banner.jpg" alt="" class="banner-img"/>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <img src="@/assets/img/icon10.png" alt="" class="img"/>
        <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
        <el-breadcrumb-item>Productor</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--		<el-tabs v-model="activeName" @tab-click="handleClick" class="products-nav">-->
    <!--			<el-tab-pane label="FAW TRACTOR TRUCK" name="1"></el-tab-pane>-->
    <!--			<el-tab-pane label="FAW DUMP TRUCK" name="2"></el-tab-pane>-->
    <!--			<el-tab-pane label="FAW CARGO TRUCK" name="3"></el-tab-pane>-->
    <!--			<el-tab-pane label="FAW SPECIAL TRUCK" name="4"></el-tab-pane>-->
    <!--			<el-tab-pane label="FAW LIGHT TRUCK" name="5"></el-tab-pane>-->
    <!--		</el-tabs>-->
    <div class="row products-list clearfix">
      <div class="col-xs-6 col-md-3 products-list-item clearfix wow flipInX" v-for="item in dataList" :key="item.id">
        <div class="products-list-item-a" @click="productDetails(item)">
          <div class="products-img">
            <img :src="item.urls !== null? item.urls[0]:''"/>
          </div>
          <div class="title line1">{{ item.mexicoNumber }}</div>
          <!--          <div class="date"><i class="iconfont">&#xe710;</i>2023-06-06</div>-->
        </div>
      </div>
    </div>
    <el-pagination background layout="prev, pager, next"
                   :page-size="limit"
                   :current-page="page"
                   :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      token: localStorage.getItem('token'),
      activeName: "1",
      dataList: [],
      page: 0,
      limit: 9,
      total: 0
    };
  },
  watch: {
    // $route: {
    //   handler() {
    //     if (!this.token) {
    //       this.$message({
    //         message: 'please log in first！',
    //         type: 'warning'
    //       });
    //       this.$router.push('/')
    //     }
    //   },
    //   immediate: false,
    //   deep: false
    // }
  },
  created() {
    // if (!this.token) {
    //   this.$router.push('/')
    // }
  },
  mounted() {
    this.getData();
  },
  methods: {
    productDetails(item) {
      this.$router.push({
        path: "/productDetails",
        query: {
          vehicleInfo: JSON.stringify(item)
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getData() {
      this.$request({
        url: '/app/vehicleInfo/list',
        method: 'get',
        params: {page: this.page, limit: this.limit}
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.total = data.page.totalPage
        } else {
          this.$message.error(data.msg)
        }
      })

    },
  },
};
</script>

<style lang="scss" scoped>
.products-center-list {
  .products-list {
    .products-list-item {
    }

    .products-list-item-a {
      cursor: pointer;
      color: #808080;
      // box-shadow: 3px 3px 5px #e5e5e5;
      // background-color: #f4f6fa;
      border: 1px solid #e0e0e0;
      margin: 0 0 20px 0;
      transition: all 0.6s;
      display: block;
      overflow: hidden;
    }

    .products-list-item-a:hover {
      transform: scale(1.1);
    }

    .products-list-item .products-img {
      width: 100%;
      height: 0;
      padding-bottom: 65%;
      position: relative;
    }

    .products-list-item .products-img img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    .products-list-item .title {
      padding: 10px 20px 5px 20px;
      font-size: 16px;
      color: #333;
    }

    .products-list-item .date {
      padding: 0 20px 15px 20px;
    }
  }
}
</style>
